import { Box, Button, createStyles, makeStyles } from '@material-ui/core';
import { SubTitle3Text, colors } from 'design-system';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      padding: '10px',
    },
  }),
);

type FooterProps = {
  onAccept: () => void;
  onCancel: () => void;
  disableAcceptButton: boolean;
};

const Footer = ({
  onAccept,
  onCancel,
  disableAcceptButton,
}: FooterProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="flex-end" className={classes.root}>
      <Button
        onClick={onCancel}
        id="sales-web-button-cancel-popover"
        data-testid="button-cancel"
      >
        <SubTitle3Text style={{ color: colors.abbey }}>Cancelar</SubTitle3Text>
      </Button>
      <Button
        onClick={onAccept}
        id="sales-web-button-accept-popover"
        disabled={disableAcceptButton}
        data-testid="button-accept"
      >
        <SubTitle3Text
          style={
            disableAcceptButton
              ? { color: colors.silver }
              : { color: colors.bright_turquoise }
          }
          data-testid="text-accept"
        >
          Aplicar
        </SubTitle3Text>
      </Button>
    </Box>
  );
};

export default Footer;
